// extracted by mini-css-extract-plugin
export var buttonContainer = "_6p-1";
export var fontSizeSelect = "_6p-3";
export var formatSelect = "_6p-2";
export var formats = "_6p-4";
export var hidden = "_6p-5";
export var icon = "_6p-6";
export var select = "_6p-0";